import { render, staticRenderFns } from "./NewRuleDialogue.vue?vue&type=template&id=6675bc07&scoped=true"
import script from "./NewRuleDialogue.vue?vue&type=script&lang=ts"
export * from "./NewRuleDialogue.vue?vue&type=script&lang=ts"
import style0 from "./NewRuleDialogue.vue?vue&type=style&index=0&id=6675bc07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675bc07",
  null
  
)

export default component.exports